// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Ynth8vx{display:flex;align-items:center;padding:1em;border-radius:1em;background:#fff}@media(min-width: 600px){.Ynth8vx{padding:1.125em 1.5em}}.hz9T8WU,.Ynth8vx .hz9T8WU{padding-left:.75em;font-family:var(--display-font-family);font-size:14px;line-height:1.2}@media(min-width: 600px){.hz9T8WU,.Ynth8vx .hz9T8WU{padding-left:.666em;font-size:18px}}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `Ynth8vx`,
	"title": `hz9T8WU`
};
export default ___CSS_LOADER_EXPORT___;
